import { createFileRoute } from "@tanstack/react-router";
import { RunsPage, runsSearchSchema } from "@/features/automation/runs-page";

export const Route = createFileRoute("/_app/automation/runs")({
  validateSearch: runsSearchSchema,
  head: () => ({ meta: [{ title: "Automation log · Malfak" }] }),
  component: RunsRoute,
});

function RunsRoute() {
  const search = Route.useSearch();
  return <RunsPage search={search} />;
}
